/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}[_nghost-%COMP%]   .dashboard-layout[_ngcontent-%COMP%]{height:100%}[_nghost-%COMP%]   .offline-message[_ngcontent-%COMP%]{color:#fff;background:#f4502e;height:48px;display:flex;justify-content:center;align-items:center}[_nghost-%COMP%]   .offline-message[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#fff}[_nghost-%COMP%]   .messages[_ngcontent-%COMP%]{padding:0;background:0 0;flex:1 1 0;position:relative;overflow-y:overlay;overflow-x:hidden;display:flex;flex-direction:column}"];
export { styles as styles };
